import loader from '@assets/loader.gif';
import Card from '../Card';
import * as style from './index.css';

const Loading = ({ message }: { message?: string }) => (
  <div className={style.wrapper} data-testid='test_loading'>
    <Card className={style.card}>
      <img className={style.image} src={loader} alt='' />
      {message && <p className={style.message}>{message}</p>}
    </Card>
  </div>
);

export default Loading;
